import type { Recipe } from '../../types'
import { image, ingredient, section } from '../helpers'

export const tarteAuFromageDeMamie: Recipe = {
  slug: 'tarte-au-fromage-de-mamie',
  title: 'Tarte au fromage de mamie',
  category: 'salé',
  description: 'Une tarte épaisse et généreuse au pain au lait, aux oignons fondants et au comté.',
  image: image('tarte-au-fromage-de-mamie'),
  tags: ['comté', 'oignons', 'four à pizza'],
  meta: [
    { label: 'Préparation', value: '20 min, plus 3 à 5 h de levée' },
    { label: 'Cuisson', value: '20 min à 220 °C ou 10 min à 275–300 °C' },
  ],
  sections: [
    section('Pâte au lait', [
      ingredient('farine', 'farine', '500 g de farine', { amount: 500, unit: 'g', shoppingKey: 'farine' }),
      ingredient('levure', 'levure de boulanger', '20 g de levure de boulanger fraîche', {
        amount: 20,
        unit: 'g',
        shoppingKey: 'levure de boulanger',
      }),
      ingredient('lait', 'lait', '300 g de lait', { amount: 300, unit: 'g', shoppingKey: 'lait' }),
      ingredient('sel', 'sel', '10 g de sel', { amount: 10, unit: 'g', shoppingKey: 'sel' }),
    ]),
    section('Garniture', [
      ingredient('oignon', 'oignon', '1 gros oignon', { amount: 1, unit: 'oignon', shoppingKey: 'oignon' }),
      ingredient('beurre', 'beurre', 'Un peu de beurre pour la poêle', { shoppingKey: 'beurre' }),
      ingredient('vin-blanc', 'vin blanc', 'Environ 10 cl de vin blanc', {
        amount: 10,
        unit: 'cl',
        shoppingKey: 'vin blanc',
      }),
      ingredient('condiment', 'condiment', 'Condiment, pour le fond de la pâte', { shoppingKey: 'condiment' }),
      ingredient('creme', 'crème', '40 g de crème', { amount: 40, unit: 'g', shoppingKey: 'crème' }),
      ingredient('comte', 'comté râpé', 'Environ 100 g de comté râpé', {
        amount: 100,
        unit: 'g',
        shoppingKey: 'comté',
      }),
    ]),
  ],
  steps: [
    'Mélanger la farine, la levure de boulanger, le lait et le sel dans le bol du KitchenAid, puis pétrir jusqu’à obtenir une pâte homogène. Bouler la pâte et la laisser reposer 3 à 4 heures à couvert.',
    'Pour une pâte plus légère, étaler la pâte sur un papier cuisson huilé et fariné, puis la laisser encore lever une heure à couvert.',
    'Émincer finement l’oignon. Le faire mourir dans une poêle avec un peu de beurre, puis déglacer avec un trait de vin blanc et laisser réduire.',
    'Étaler le condiment sur le fond de la pâte.',
    'Répartir les oignons fondants sur la pâte.',
    'Mélanger la crème avec une cuillère à soupe de vin blanc, puis la verser sur les oignons.',
    'Terminer avec le comté râpé.',
    'Cuire au four traditionnel environ 20 minutes à 220 °C, chaleur tournante, ou au four à pizza 10 minutes à 275–300 °C en surveillant attentivement la coloration.',
  ],
  note: 'La tarte est volontairement très épaisse et se cuit sans bord : la pâte et la garniture forment un seul disque moelleux et généreux.',
}
